// extracted by css-extract-rspack-plugin
export default {"Tooltip":"hGSPBq9UknhRU2GX","Tooltip-popover-content":"IB01CKVUBXkf40DY"};